// ============================================
// SLIDER HISTORY
// Interaktywny slider z osią czasu
// ============================================

(function () {
    'use strict';

    function initSliderHistory() {
        const slider = document.querySelector('.slider-history');
        if (!slider) return;

        const track = slider.querySelector('.slider-history__track');
        const slides = slider.querySelectorAll('.slider-history__slide');
        const paginationItems = slider.querySelectorAll('.slider-history__pagination-item');
        const dots = slider.querySelectorAll('.slider-history__dot');
        const prevBtn = slider.querySelector('.slider-history__nav-arrow--prev');
        const nextBtn = slider.querySelector('.slider-history__nav-arrow--next');
        const slidesContainer = slider.querySelector('.slider-history__slides');

        var currentIndex = 0;
        var totalSlides = slides.length;
        var mobileBreakpoint = 769;

        function isMobile() {
            return window.innerWidth < mobileBreakpoint;
        }

        function updateSlideHeight() {
            if (isMobile()) {
                var activeSlide = slides[currentIndex];
                if (activeSlide) {
                    slidesContainer.style.height = activeSlide.scrollHeight + 'px';
                }
            } else {
                slidesContainer.style.height = '';
            }
        }

        // Apply background color from data-bg-color attribute
        function applyBgColor(index) {
            var slide = slides[index];
            if (!slide) return;
            var bgColor = slide.getAttribute('data-bg-color');
            if (bgColor) {
                slidesContainer.style.backgroundColor = bgColor;
                // Also set mobile slide content background
                if (isMobile()) {
                    slides.forEach(function (s) {
                        var content = s.querySelector('.slider-history__slide-content');
                        if (content) {
                            content.style.backgroundColor = s.getAttribute('data-bg-color') || '';
                        }
                    });
                }
            }
        }

        function goToSlide(index) {
            if (index < 0 || index >= totalSlides) return;
            currentIndex = index;

            // Move track (slide)
            track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';

            // Toggle active slide (for mobile fade)
            slides.forEach(function (slide, i) {
                slide.classList.toggle('slider-history__slide--active', i === currentIndex);
            });

            // Update numbered pagination (desktop)
            paginationItems.forEach(function (item, i) {
                item.classList.toggle('slider-history__pagination-item--active', i === currentIndex);
            });

            // Update dots (mobile)
            dots.forEach(function (dot, i) {
                dot.classList.toggle('slider-history__dot--active', i === currentIndex);
            });

            // Update arrows
            if (prevBtn) {
                prevBtn.classList.toggle('slider-history__nav-arrow--disabled', currentIndex === 0);
            }
            if (nextBtn) {
                nextBtn.classList.toggle('slider-history__nav-arrow--disabled', currentIndex === totalSlides - 1);
            }

            // Apply slide background color
            applyBgColor(currentIndex);

            // Update container height for mobile
            updateSlideHeight();
        }

        // Recalculate height on resize
        window.addEventListener('resize', function () {
            updateSlideHeight();
            applyBgColor(currentIndex);
        });

        // Numbered pagination click
        paginationItems.forEach(function (item) {
            item.addEventListener('click', function () {
                var slideIndex = parseInt(this.getAttribute('data-slide'), 10);
                goToSlide(slideIndex);
            });
        });

        // Dot pagination click
        dots.forEach(function (dot) {
            dot.addEventListener('click', function () {
                var slideIndex = parseInt(this.getAttribute('data-slide'), 10);
                goToSlide(slideIndex);
            });
        });

        // Arrow navigation
        if (prevBtn) {
            prevBtn.addEventListener('click', function () {
                goToSlide(currentIndex - 1);
            });
        }
        if (nextBtn) {
            nextBtn.addEventListener('click', function () {
                goToSlide(currentIndex + 1);
            });
        }

        // Touch/swipe support for mobile
        var touchStartX = 0;
        var touchEndX = 0;
        var isSwiping = false;

        track.addEventListener('touchstart', function (e) {
            touchStartX = e.changedTouches[0].screenX;
            isSwiping = true;
        }, { passive: true });

        track.addEventListener('touchend', function (e) {
            if (!isSwiping) return;
            touchEndX = e.changedTouches[0].screenX;
            var diff = touchStartX - touchEndX;

            if (Math.abs(diff) > 50) {
                if (diff > 0) {
                    goToSlide(currentIndex + 1); // swipe left → next
                } else {
                    goToSlide(currentIndex - 1); // swipe right → prev
                }
            }
            isSwiping = false;
        }, { passive: true });

        // Keyboard navigation
        slider.setAttribute('tabindex', '0');
        slider.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowLeft') {
                goToSlide(currentIndex - 1);
            } else if (e.key === 'ArrowRight') {
                goToSlide(currentIndex + 1);
            }
        });

        // Initialize first slide
        goToSlide(0);
    }

    document.addEventListener('DOMContentLoaded', initSliderHistory);
})();
